import { isWeb } from 'shared/src/utils';
import { useGoodsSno } from './useGoodsSno';
import { usePostAffiliateLinksAccessLogs } from '../queries/usePostAffiliateLinksAccessLogs';
import { useGoodsRoute } from '../../../hooks/useGoodsRoute';
import { useRetainedEffect } from 'shared/src/hooks/retainedState';

export const useAffiliateAccessLog = () => {
  const goodsSno = useGoodsSno();
  const { mutate } = usePostAffiliateLinksAccessLogs();
  const { params } = useGoodsRoute<'GoodsDetail'>();

  useRetainedEffect(
    'affiliate-access-log',
    () => {
      // 방문당 1회 — remount(같은 visit) 재발화로 정산 POST 중복 방지.
      if (isWeb) {
        const searchParams = new URLSearchParams(window.location.search);
        const uid = searchParams.get('uid');
        if (!uid) return false;
        mutate({ uid, goods_sno: goodsSno });
        searchParams.delete('uid');
        const nextSearch = searchParams.toString();
        const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}`;
        window.history.replaceState(null, '', nextUrl);
        return;
      }

      const uid = params.extras?.uid;
      if (!uid) return false;
      mutate({ uid, goods_sno: goodsSno });
    },
    [goodsSno, mutate, params.extras?.uid],
  );
};